import * as React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import { uniformUrl } from '../../helpers/StringHelpers'

export const TaggedLandingPages = ({ section, className = 'py-6 leading-loose' }) => {
  const getName = landingPage => {
    let tag = landingPage.tag
    if (Array.isArray(tag)) {
      tag = tag[0]
    }
    if (!tag) {
      return landingPage.title
    }
    switch (section.linkName) {
      case 'Page Title':
        return landingPage.title
      case 'Tag: Location':
        return tag.location
      case 'Tag: Model':
        return tag.model
      case 'Tag: Model Number':
        return tag.modelNumber
      case 'Tag: Category':
        return tag.category
      case 'Tag: Service':
        return tag.service
      case 'Tag: Brand':
        return tag.brand
      case 'Tag: Custom':
        return tag.custom
      default:
        return landingPage.title
    }
  }
  const landingPages = section.tag
    .map(tag =>
      tag.landingPages.map(landingPage => {
        return {
          name: getName(landingPage),
          url: landingPage.urlPath,
        }
      })
    )
    .flat()
    .sort((a, b) => a.name.localeCompare(b.name))

  return (
    <section className="w-full bg-gray-100">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 w-10/12 2xl:w-full max-w-[1366px] mx-auto py-10 gap-3 lg:gap-8 text-zinc-700">
        <h2 className="sm:col-span-2 xl:col-span-3 text-xl lg:text-2xl font-bold uppercase">
          {section.heading}
        </h2>
        {landingPages.map((landingPage, index) => {
          return (
            <Link
              to={uniformUrl(landingPage.url)}
              className="lg:text-xl uppercase block hover:translate-x-1 duration-300 ease-in-out"
              key={index}
            >
              {section.prefixLink}
              {landingPage.name}
            </Link>
          )
        })}
      </div>
    </section>
  )
}

TaggedLandingPages.propTypes = {
  section: PropTypes.shape({
    heading: PropTypes.string,
    linkName: PropTypes.string,
    prefixLink: PropTypes.string,
    tag: PropTypes.arrayOf(
      PropTypes.shape({
        landingPages: PropTypes.arrayOf(
          PropTypes.shape({
            tag: PropTypes.shape({
              brand: PropTypes.string,
              category: PropTypes.string,
              model: PropTypes.string,
              modelNumber: PropTypes.string,
              service: PropTypes.string,
              location: PropTypes.string,
            }),
            title: PropTypes.string,
            urlPath: PropTypes.string,
          })
        ),
      })
    ),
  }),

  className: PropTypes.string,
}

export const query = graphql`
  fragment TaggedLandingPages on STRAPI__COMPONENT_SECTION_TAGGED_LANDING_PAGES {
    id
    strapi_component
    prefixLink
    linkName
    heading
    tag {
      landingPages {
        tag {
          brand
          category
          model
          modelNumber
          service
          location
          custom
        }
        title
        urlPath
      }
    }
  }
`

export default TaggedLandingPages
